import React from 'react';
import { Container } from 'react-bootstrap';
import AboutHeader from '../components/AboutHeader';
import WhySEPL from '../components/WhySEPL';
import MissionVision from '../components/MissionVision';
import OurHistory from '../components/Timeline';
import 'aos/dist/aos.css';
import AOS from 'aos';

const AboutPage = () => {
  React.useEffect(() => {
    AOS.init({ duration: 1200, once: true, easing: 'ease-in-out' });
  }, []);

  return (
    <div>
      <AboutHeader />

      {/* <Container className="py-5  who-we-are-section" data-aos="fade-up">
        <h2 className="text-center mb-4 fw-bold highlight">Who We Are</h2>
        <p className="text-center mx-auto" style={{ maxWidth: "800px", fontSize: '1.40rem', lineHeight: '1.6', color: '#004085' }}>
          SEPL Industries is a trusted name in IT, networking, telecom, and managed services. 
          With a mission to empower businesses through secure and scalable solutions, we bring 
          over a decade of industry experience to help you stay ahead in the digital age.
        </p>

        <h3 className="mt-5 mb-4 text-center fw-semibold highlight" data-aos="fade-up" data-aos-delay="200">Why SEPL?</h3>
        <div data-aos="fade-up" data-aos-delay="400">
          <WhySEPL />
        </div>
      </Container> */}

      {/* History Timeline */}
<section className=" pt-0 timeline-section-wrapper" data-aos="fade-up" data-aos-delay="800">
        <Container>
          <OurHistory />
        </Container>
      
</section>
      {/* Mission & Vision Grid */}
      <section className="py-5" data-aos="fade-up" data-aos-delay="800">
        <Container>
          <MissionVision />
        </Container>
      </section>
    </div>
  );
};

export default AboutPage;
